import { selectWarehouseStatesIsLoading } from 'containers/Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import { GATEWAY_STATUS } from 'utils/constants'
import { useReduxSelector } from 'store'
import GateAlert from './GateAlert'
import React from 'react'

interface GatewayProps {
  status?: warehouse.GatewayState
  /** alert najmu (te same co na magazynie, bez alarmu) */
  alert?: warehouse.WarehouseAlert
}

const mmApp = process.env.REACT_APP_TYPE === 'mm'

const Gateway: React.FC<GatewayProps> = ({ status = GATEWAY_STATUS.closed, alert }) => {
  const isLoading = useReduxSelector(selectWarehouseStatesIsLoading)
  const { t } = useTranslation('basic')

  return (
    <div className='gateGateway__container'>
      <svg id="gateway" viewBox="0 0 183 265" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <g id="gateway_door" className={status === "gateway_opened" ? "--opened" : undefined}>
            <rect x="19.6289" y="21.8101" width="146.122" height="228.997" fill="#0F0F0F" />
            <rect x="19.6289" y="43.6172" width="146.122" height="13.0855" fill="url(#gateway_door_1)" />
            <rect x="19.6289" y="100.323" width="146.122" height="13.0855" fill="url(#gateway_door_2)" />
            <rect x="19.6289" y="155.937" width="146.122" height="13.0855" fill="url(#gateway_door_3)" />
            <rect x="19.6289" y="219.184" width="146.122" height="13.0855" fill="url(#gateway_door_4)" />
            {mmApp && <>
              <path d="M82.1633 122.296C81.7742 122.296 81.4011 122.451 81.126 122.726C80.8508 123.001 80.6963 123.374 80.6963 123.763V138.315C80.6963 138.704 80.8508 139.077 81.126 139.352C81.4011 139.628 81.7742 139.782 82.1633 139.782H82.8737V138.581H82.1139C82.0788 138.581 82.0441 138.574 82.0117 138.56C81.9792 138.547 81.9498 138.527 81.925 138.502C81.9002 138.478 81.8805 138.448 81.8671 138.416C81.8536 138.383 81.8467 138.349 81.8467 138.314V123.763C81.8467 123.692 81.8749 123.624 81.925 123.574C81.9751 123.524 82.043 123.496 82.1139 123.496H84.0828V123.056C84.0845 122.8 84.1104 122.545 84.16 122.294L82.1633 122.296ZM103.021 122.296H101.042C101.069 122.461 101.084 122.627 101.086 122.794V123.497H103.071C103.142 123.497 103.21 123.526 103.26 123.576C103.31 123.626 103.338 123.694 103.338 123.765V138.314C103.338 138.349 103.331 138.383 103.318 138.416C103.304 138.448 103.284 138.478 103.26 138.502C103.235 138.527 103.205 138.547 103.173 138.56C103.141 138.574 103.106 138.581 103.071 138.581H102.299V139.782H103.025C103.414 139.782 103.787 139.628 104.063 139.352C104.338 139.077 104.492 138.704 104.492 138.315V123.763C104.492 123.57 104.454 123.379 104.38 123.201C104.306 123.022 104.198 122.861 104.061 122.724C103.925 122.588 103.762 122.48 103.584 122.407C103.406 122.333 103.214 122.295 103.021 122.296Z" fill="white" />
              <path d="M99.5351 141.756C99.521 141.758 99.5067 141.758 99.4926 141.756H96.5176C96.4974 141.759 96.4769 141.758 96.4571 141.753C96.4373 141.748 96.4188 141.739 96.4025 141.727C96.3862 141.715 96.3724 141.699 96.3621 141.682C96.3518 141.664 96.3451 141.645 96.3423 141.624C96.3403 141.61 96.3403 141.596 96.3423 141.582V123.496H94.2476L94.2437 138.379V141.655C94.2437 141.723 94.1858 141.757 94.0692 141.757H91.095C90.9784 141.757 90.9197 141.723 90.9197 141.655V123.495H88.8235V141.578C88.8268 141.602 88.8246 141.626 88.817 141.649C88.8094 141.671 88.7965 141.692 88.7795 141.709C88.7625 141.726 88.7418 141.739 88.719 141.746C88.6962 141.754 88.6719 141.756 88.6482 141.752H85.6755C85.6553 141.755 85.6348 141.754 85.615 141.749C85.5952 141.744 85.5766 141.735 85.5603 141.723C85.544 141.711 85.5303 141.695 85.52 141.678C85.5097 141.66 85.503 141.641 85.5002 141.62C85.4986 141.606 85.4986 141.592 85.5002 141.578V123.19C85.5022 122.887 85.5434 122.586 85.623 122.294C85.7625 121.629 86.1283 121.032 86.6583 120.607C87.1882 120.181 87.8495 119.952 88.5293 119.959H96.445C97.1621 119.9 97.876 120.104 98.4528 120.534C99.0295 120.964 99.4295 121.59 99.5775 122.294C99.6329 122.516 99.6627 122.743 99.6663 122.971V141.578C99.6697 141.598 99.669 141.619 99.6642 141.639C99.6594 141.659 99.6506 141.678 99.6384 141.695C99.6261 141.712 99.6107 141.726 99.5929 141.736C99.5752 141.747 99.5555 141.754 99.5351 141.756V141.756Z" fill="white" />
            </>}
            <g filter="url(#gateway_filter)">
              <path d="M89.4185 259.529C129.769 259.529 162.48 259.285 162.48 258.984C162.48 258.683 129.769 258.438 89.4185 258.438C49.068 258.438 16.3574 258.683 16.3574 258.984C16.3574 259.285 49.068 259.529 89.4185 259.529Z" fill="black" />
            </g>
          </g>
          <g>
            <rect width="16.357" height="260.62" transform="matrix(-1 0 0 1 16.3574 0)" fill="#0F0F0F" />
            <rect x="165.751" width="16.357" height="260.62" fill="#0F0F0F" />
            <path d="M19.6289 3.41637L16.3575 0V260.62L19.6289 249.395V3.41637Z" fill="#232323" />
            <path d="M162.48 3.41637L165.752 0V260.62L162.48 249.395V3.41637Z" fill="#232323" />
          </g>
        </g>

        <defs>
          <filter id="gateway_filter" x="10.9574" y="253.038" width="156.922" height="11.8903" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.7" result="effect1_foregroundBlur_1538_2" />
          </filter>
          <linearGradient id="gateway_door_1" x1="92.69" y1="56.7027" x2="92.69" y2="43.6172" gradientUnits="userSpaceOnUse">
            <stop />
            <stop offset="0.129808" stopColor="#101010" />
            <stop offset="0.855769" stopColor="#1A1A1A" />
            <stop offset="1" stopColor="#282828" />
          </linearGradient>
          <linearGradient id="gateway_door_2" x1="92.69" y1="113.408" x2="92.69" y2="100.323" gradientUnits="userSpaceOnUse">
            <stop />
            <stop offset="0.129808" stopColor="#101010" />
            <stop offset="0.855769" stopColor="#1A1A1A" />
            <stop offset="1" stopColor="#282828" />
          </linearGradient>
          <linearGradient id="gateway_door_3" x1="92.69" y1="169.023" x2="92.69" y2="155.937" gradientUnits="userSpaceOnUse">
            <stop />
            <stop offset="0.129808" stopColor="#101010" />
            <stop offset="0.855769" stopColor="#1A1A1A" />
            <stop offset="1" stopColor="#282828" />
          </linearGradient>
          <linearGradient id="gateway_door_4" x1="92.69" y1="232.269" x2="92.69" y2="219.184" gradientUnits="userSpaceOnUse">
            <stop />
            <stop offset="0.129808" stopColor="#101010" />
            <stop offset="0.855769" stopColor="#1A1A1A" />
            <stop offset="1" stopColor="#282828" />
          </linearGradient>
        </defs>
      </svg>
      {isLoading
        ? <div className='gateGateway__popup'>
          <div className='popup__title'>
            <div>{t('resyncStatus')}</div>
          </div>
        </div>
        : alert
          ? <GateAlert {...alert} />
          : null}
    </div>
  )
}

export default Gateway